// extracted by mini-css-extract-plugin
export default {"modalOverlay":"styles_modalOverlay__43oQx","modalContent":"styles_modalContent__Mr5D4","logo":"styles_logo__It9Pl","close":"styles_close__x-uNs"};